import { render, staticRenderFns } from "./RoomCallCamstudyP2PVideo.vue?vue&type=template&id=7a15bcce&scoped=true&"
import script from "./RoomCallCamstudyP2PVideo.vue?vue&type=script&lang=js&"
export * from "./RoomCallCamstudyP2PVideo.vue?vue&type=script&lang=js&"
import style0 from "./RoomCallCamstudyP2PVideo.vue?vue&type=style&index=0&id=7a15bcce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a15bcce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a15bcce')) {
      api.createRecord('7a15bcce', component.options)
    } else {
      api.reload('7a15bcce', component.options)
    }
    module.hot.accept("./RoomCallCamstudyP2PVideo.vue?vue&type=template&id=7a15bcce&scoped=true&", function () {
      api.rerender('7a15bcce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/p2p/RoomCallCamstudyP2PVideo.vue"
export default component.exports